import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSetting } from '../../../shared/hooks/useApi/useSetting';
import { usePayment } from '../../../shared/hooks/useApi/usePayment';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import ProductCard from '../ProductCard';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import belowIcon from '../../../asset/icon/below.png';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { AlertPosition, AlertType } from '../../../shared/enum/EnumRepository';
import { getAlertMessage } from '../../../shared/constants/alertMessages';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';

const SubscriptionModalMobile: React.FC = () => {
  const { user } = useAuth();
  const { setting } = useSetting();
  const { standardModal, clearModal } = useModalStore();
  const { product, getProduct } = usePayment();
  const { enqueueAlert } = useStandardAlertStore();

  useEffect(() => {
    if (product) return;
    getProduct();
  }, []);

  if (!setting || standardModal == null || !user || !product) return null;

  const handleMoveToSubscribe = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    enqueueAlert({
      type: AlertType.ALERT,
      position: AlertPosition.TOP,
      content: getAlertMessage('SUBSCRIBE_USE_DESKTOP'),
      callBack: () => {
        clearModal();
      }
    });
  }

  const handleClose = () => {
    clearModal(400);
  };

  return (
    <SubscriptionModalComp>
      <TitleWrapper>
        <ModalTitle>{getModalMessage('SUBSCRIPTION_TITLE')}</ModalTitle>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={handleClose}
        />
      </TitleWrapper>
      <SubscriptionComp>
        <ProductCard />
      </SubscriptionComp>
      <HeadlessBtn
        value={getBtnName('MOVE_TO_SUBSCRIBE')}
        handleClick={handleMoveToSubscribe}
        StyledBtn={SubmitButton}
      />
    </SubscriptionModalComp>
  );
}

const SubscriptionModalComp = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const ModalTitle = styled.h2`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`;


const SubscriptionComp = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  overflow-x: hidden;
`;

const SubmitButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

export default SubscriptionModalMobile;
